export const PLAIN_SHELL_PREFIXES = [
  '/login',
  '/signup',
  '/sso-login',
  '/sso_callback',
  '/sso-callback',
  '/reset-password',
  '/waitlist',
  '/onboarding',
] as const;

export function isPlainShellPath(pathname: string): boolean {
  return PLAIN_SHELL_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
